import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { ITransactionExtensionFieldName } from '@/Interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionExtensionFieldNameModal',
  props: {
    model: { type: null, required: true }
  },
  emits: ["close", "update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void;
  (e: 'update', model: ITransactionExtensionFieldName): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  model: ITransactionExtensionFieldName
};

const maxDisplayNameLength = 80;




const model = ref(structuredClone(props.model));

const validationError = computed(() => {
  const displayName = model.value.displayName ?? '';
  if (displayName.length > maxDisplayNameLength) {
    return 'Custom field name is too large.';
  }
  return '';
});

const handleUpdate = () => {
  if (!validationError.value) {
    emits('update', model.value);
  }
};

return { __sfc: true,maxDisplayNameLength, props, emits, model, validationError, handleUpdate }
}

})